export const decision = {
  namespaced: true,
  state: {
    processType: '',
    customerType: ''
  },
  getters: {
    getProcessType (state) {
      return state.processType
    },
    getCustomerType (state) {
      return state.customerType
    }
  },
  actions: {
    onProcessDecision (context, processType) {
      context.commit('addProcessType', processType)
    },
    onCustomerDecision (context, customerType) {
      context.commit('addCustomerType', customerType)
    }
  },
  mutations: {
    addProcessType (state, type) {
      state.processType = type
    },
    addCustomerType (state, type) {
      state.customerType = type
    }
  }
}
